/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WoundIdentificationAssessmentViewModel } from './WoundIdentificationAssessmentViewModel'; 

export function getWoundIdentificationAssessmentOptions(visitId: string, onSuccess?: (result: WoundIdentificationAssessmentViewModel) => void) {
	return queryOptions({
		queryKey: ['wound-identification-assessment', visitId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/woundmanagement/queries/getwoundidentificationassessment/' + visitId;
			const resp = await axios.get<WoundIdentificationAssessmentViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(visitId)
	});
}